import React, { useCallback, useContext, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import styles from './payment.module.css'
import '../../components/text/Text.css'
import Text from '../../components/text/Text'
import qrSvg from '../../assets/icons/icons-qr-payment.svg'
import bciPayLogo from '../../assets/icons/bci-pagos-logo.png'
import getnetPayLogo from '../../assets/icons/getnet-pagos-logo.png'
import cash from '../../assets/icons/cash.png'
import cashOk from '../../assets/icons/cash-ok.png'
import posnet from '../../assets/images/posnet.png'
import posnetModal from '../../assets/images/posnetModal.png'

import qrDisabled from '../../assets/icons/icons-disabled-qr.svg'
import arrowBack from '../../assets/icons/icons-arrow-back.svg'
import routes from '../../router/routes'
import {
    createPaymentOrder,
    getProcessedBciPayment,
    processBciPayment,
    processCashPayment,
    getProcessedGetnetPayment,
    processGetnetPayment,
    processPOSManualPayment,
} from '../../services/payment'
import { labels } from '../../labels'
import { useLoadingContext } from '../../context/spinnerContext'
import { FeatureContext } from '../../context/useFeatureFlagContext'

import { getLastPromotionCreated } from '../../services/promotions'
import moment from 'moment'
import ModalComponent from '../../components/modal/ModalComponent'
import { getLocal, getLocalId } from '../../Utils/Profile'
import SvgIcon from '../../components/svgIcon/SvgIcon'
import { ICartProduct } from '../cart/cart'
import { formatCurrency } from '../../utils'
import SquareCheckBox from '../../components/checkBox/SquareCheckBox'

export interface PromotionInfo {
    sPromocion: string
    nDescuento: string
    dInicio: string
    dTermino: string
    bJueves: boolean
    bLunes: boolean
    bMartes: boolean
    bMiercoles: boolean
    bSabado: boolean
    bTiendaOnline: boolean
    bTiendaPresencial: boolean
    bViernes: boolean
    bDomingo: boolean
    tInicio: string
    tTermino: string
    nMontoMinimo: string
    sTipo: string
    sEstado: string
    idPromocion: string
    stock?: number | string
}

export default function Payment() {
    const navigation = useNavigate()
    const location = useLocation()

    const [showMessageEfecty, setShowMessageEfecty] = useState(false)

    const { features } = useContext(FeatureContext)

    const loadingContext = useLoadingContext()
    const [price, setPrice] = useState<string>('')
    const [processBCI, setProcessBCI] = useState<boolean>(false)
    const [showPromotionModal, setShowPromotionModal] = useState(false)
    const [showCashModal, setShowCashModal] = useState(false)

    const [showManualPOSModal, setShowManualPOSModal] = useState<boolean>(false)

    const [doNotShowAgain, setDoNotShowAgain] = useState<boolean>(() => {
        const saved = localStorage.getItem('doNotShowAgain')
        return saved ? JSON.parse(saved) : false
    })

    const [cart, setCart] = useState<ICartProduct[] | undefined>()

    useEffect(() => {
        localStorage.setItem('doNotShowAgain', JSON.stringify(doNotShowAgain))
    }, [doNotShowAgain])

    useEffect(() => {
        if (location.state?.cart) {
            setCart(location.state.cart)
        }
    }, [])

    const [processGetnet, setProcessGetnet] = useState<boolean>(false)

    const [promotionInfo, setPromotionInfo] = useState<PromotionInfo | null>(
        null
    )

    const currentUser = localStorage.getItem('currentUser')
    const hasBCIOrderPending = localStorage.getItem('bci-payment')
    const hasGetnetOrderPending = localStorage.getItem('getnet-payment')

    const getTotalCart = () => {
        if (cart && cart.length > 0) {
            return cart.reduce(
                (acc, curr) =>
                    acc + curr.cant * curr.productPrices[0].saleAmount,
                0
            )
        }

        return 0
    }

    const getTotalPrice = () => {
        const _value = parseFloat(price.replace('$', ''))

        if (isNaN(_value)) {
            return 0
        }

        return _value
    }

    const getTotalPay = useCallback(() => {
        const _value = parseFloat(price.replace('$', ''))

        if (isNaN(_value)) {
            return getTotalCart()
        }

        return getTotalCart() + _value
    }, [price, getTotalCart])

    const getTotalPayWithPromotion = useCallback(() => {
        const total = getTotalPay()

        if (promotionInfo?.nDescuento) {
            if (!isNaN(Number(promotionInfo.nDescuento))) {
                const discount =
                    total * (Number(promotionInfo.nDescuento) / 100)
                const totalWD = total - discount

                const decimalPart = totalWD - Math.floor(totalWD)

                const finalPrice =
                    decimalPart < 0.5 ? Math.floor(totalWD) : Math.ceil(totalWD)

                return finalPrice
            }
        }

        return total
    }, [getTotalPay, promotionInfo])

    const user = currentUser && JSON.parse(currentUser)

    const checkBCIPending = async () => {
        if (hasBCIOrderPending) {
            try {
                const { status } = await getProcessedBciPayment(
                    hasBCIOrderPending
                )
                if (status === 'PENDING') {
                    return true
                } else {
                    localStorage.removeItem('bci-payment')
                }
            } catch (e) {
                console.log('ERROR BCI', e)
            }
            return false
        }
    }

    const handleOnProcessBCI = () => {
        setProcessBCI(true)
    }

    useEffect(() => {
        if (processBCI) {
            loadingContext?.onOpen()
            navigateToBciPayment()
        }
    }, [processBCI])

    const navigateToBciPayment = async () => {
        const pendingBCIOrder = await checkBCIPending()
        if (pendingBCIOrder) {
            loadingContext?.onClose()
            alert(
                'Hay un pago pendiente en la terminal de pago. Por favor, finalice esa orden antes de continuar.'
            )
            setProcessBCI(false)

            return null
        }
        const sEstablecimiento = user?.sEstablecimiento
        const store = getLocal()
        const data = {
            cart: cart || [],
            storeID: store,
            amount: getTotalPay(),
            commerceID: sEstablecimiento,
            inventoryAmount: getTotalCart(),
            additionalAmount: getTotalPrice(),
        }
        processBciPayment(store, data)
            .then(async (resp: any) => {
                localStorage.setItem('bci-payment', resp.buyOrder)
                loadingContext?.onClose()
                navigation(`/${routes.bci}`)
            })
            .catch((error) => {
                console.error(error)
            })
            .finally(() => {
                loadingContext?.onClose()
                setProcessBCI(false)
            })
    }

    //Inicio Getnet handleOnProcessGetnet
    const checkGetnetPending = async () => {
        if (hasGetnetOrderPending) {
            try {
                const { status } = await getProcessedGetnetPayment(
                    hasGetnetOrderPending
                )
                if (status === 'PENDING') {
                    return true
                } else {
                    localStorage.removeItem('getnet-payment')
                }
            } catch (e) {
                console.log('ERROR Getnet', e)
            }
            return false
        }
    }
    const handleOnProcessGetnet = () => {
        setProcessGetnet(true)
    }
    useEffect(() => {
        if (processGetnet) {
            loadingContext?.onOpen()
            navigateToGetnetPayment()
        }
    }, [processGetnet])

    const navigateToGetnetPayment = async () => {
        const pendingGetnetOrder = await checkGetnetPending()
        if (pendingGetnetOrder) {
            loadingContext?.onClose()
            alert(
                'Hay un pago pendiente en la terminal de pago. Por favor, finalice esa orden antes de continuar.'
            )
            setProcessGetnet(false)

            return null
        }
        const sEstablecimiento = user?.sEstablecimiento
        const store = getLocal()
        const data = {
            cart: cart || [],
            storeID: store,
            commerceID: sEstablecimiento,
            inventoryAmount: getTotalCart(),
            additionalAmount: getTotalPrice(),
            amount: getTotalPayWithPromotion(),
        }
        processGetnetPayment(store, data)
            .then(async (resp: any) => {
                localStorage.setItem('getnet-payment', resp.buyOrder)
                loadingContext?.onClose()
                navigation(`/${routes.getnet}`, {
                    state: { data: resp },
                })
            })
            .catch((error) => {
                console.error(error)
            })
            .finally(() => {
                loadingContext?.onClose()
                setProcessGetnet(false)
            })
    }
    //fin Getnet

    const handleChangePrice = (data: React.FormEvent<HTMLInputElement>) => {
        const re = /[0-9\b]+$/
        if (!re.test(data.currentTarget.value)) {
            setPrice('')
        } else {
            const value = '$' + data.currentTarget.value.replace('$', '')
            setPrice(value)
        }
    }

    const navigateBack = () => {
        navigation(`${routes.home}`)
    }

    const validatePromotionInPerson = (promotion: PromotionInfo) => {
        return (
            moment(promotion.dInicio, 'DD/MM/YYYY').isSameOrBefore(
                moment(),
                'day'
            ) &&
            moment(promotion.dTermino, 'DD/MM/YYYY').isSameOrAfter(
                moment(),
                'day'
            ) &&
            Number(promotion.nMontoMinimo) <= getTotalPay()
        )
    }

    const getPromotionsQRAsync = async () => {
        try {
            loadingContext?.onOpen()
            await getLastPromotionCreated().then((resp) => {
                if (resp.lenght !== 0) {
                    if (validatePromotionInPerson(resp)) {
                        loadingContext?.onClose()
                        setPromotionInfo(resp)
                        setShowPromotionModal(true)
                    } else {
                        navigateToQRPayment()
                    }
                }
            })
        } catch (error) {
            loadingContext?.onClose()
            console.log(error)
        }
    }

    const navigateToQRPayment = async () => {
        const idLocal = getLocalId()

        const data = {
            cart: cart || [],
            inventoryAmount: getTotalCart(),
            additionalAmount: getTotalPrice(),
            sTipoPedido: 'TR',
            itemsVenta: [
                {
                    nMontoUnitario: getTotalPayWithPromotion(),
                    sDescripcion: 'Venta Tradicional',
                    sTipo: 'Venta Tradicional',
                    nCantidad: 1,
                },
            ],
        }
        loadingContext?.onOpen()
        await createPaymentOrder(idLocal, data)
            .then(async (resp: any) => {
                loadingContext?.onClose()
                if (resp[1] === 201) {
                    navigation(`/${routes.qr}`, {
                        state: {
                            price: getTotalPayWithPromotion(),
                            data: resp[0],
                        },
                    })
                }
            })
            .catch((error) => {
                loadingContext?.onClose()
                console.error(error)
            })
    }

    const handleCashSale = () => {
        setShowCashModal(true)
    }

    const handlePayWithCash = async () => {
        setShowCashModal(false)

        try {
            loadingContext?.onOpen()

            const response = await processCashPayment(getLocal(), {
                inventoryAmount: getTotalCart(),
                additionalAmount: getTotalPrice(),
                nMonto: getTotalPay(),
                cart: cart || [],
            })

            // Si el status es 200, navegamos
            if (response?.status === 200) {
                setCart(undefined)
                navigation(`/${routes.cashPayment}`, {
                    state: { fileInvoice: response?.fileInvoice },
                })
            } else {
                // Si el status no es 200, mostramos un mensaje de error
                console.error(
                    'Error en el pago:',
                    response?.message || 'Respuesta inválida'
                )
                alert('Error al cobrar con efectivo')
            }
        } catch (error) {
            console.error('Error en el pago en efectivo:', error)
            alert('Error al procesar el pago')
        } finally {
            loadingContext?.onClose()
            setShowCashModal(false)
        }
    }

    const handlePayWithPOSManual = async () => {
        setShowManualPOSModal(false)

        try {
            loadingContext?.onOpen()

            const response = await processPOSManualPayment(getLocal(), {
                inventoryAmount: getTotalCart(),
                additionalAmount: getTotalPrice(),
                nMonto: getTotalPay(),
                cart: cart || [],
            })

            if (response?.status === 200) {
                setCart(undefined)
                navigation(`/${routes.posPayment}`, {
                    state: {
                        total: formatCurrency(getTotalPay()),
                        fileInvoice: response?.fileInvoice,
                    },
                })
            } else {
                console.error(
                    'Error en el pago con POSNET:',
                    response?.message || 'Respuesta inválida'
                )
                alert('Error al cobrar con POSMANUAL')
            }
        } catch (error) {
            console.error('Error en el pago con POSMANUAL:', error)
            alert('Error al procesar el pago')
        } finally {
            loadingContext?.onClose()
            setShowManualPOSModal(false)
        }
    }

    const cashModal = () => {
        return (
            <ModalComponent
                show={showCashModal}
                handleClose={() => setShowCashModal(false)}
                modalStyle={styles.cashModalStyle}
                icon={false}
            >
                <div className={styles.contentCashOk}>
                    <img src={cashOk} className={styles.cashOkImage} />
                </div>
                <div className={styles.efectivoContent}>
                    <span className={styles.efectivoSpan}>
                        <Text
                            label={'Estás a punto de '}
                            fontSize={16}
                            fontWeight={500}
                            color="#565656"
                            textAlign="center"
                            fontFamily={'Poppins'}
                            as="span"
                        />
                        <Text
                            label="registrar un monto en efectivo"
                            fontSize={16}
                            fontWeight={700}
                            color="#565656"
                            textAlign="center"
                            fontFamily={'Poppins'}
                            as="span"
                        />
                        <Text
                            label=" de "
                            fontSize={16}
                            fontWeight={500}
                            color="#565656"
                            textAlign="center"
                            fontFamily={'Poppins'}
                            as="span"
                        />
                        <Text
                            label={formatCurrency(getTotalPay())}
                            fontSize={16}
                            fontWeight={700}
                            color="#565656"
                            textAlign="center"
                            fontFamily={'Poppins'}
                            as="span"
                        />
                    </span>
                </div>
                <Text
                    label="Recuerda que los registros de efectivo no será registrado en la proforma"
                    fontSize={16}
                    fontWeight={500}
                    color="#565656"
                    textAlign="center"
                    fontFamily={'Poppins'}
                />
                <Text
                    label="amiPASS"
                    fontSize={16}
                    fontWeight={700}
                    color="#565656"
                    marginBottom={20}
                    textAlign="center"
                    fontFamily={'Poppins'}
                />

                <Text
                    label="¿Está correcto?"
                    fontSize={16}
                    fontWeight={700}
                    color="#565656"
                    marginBottom={20}
                    textAlign="center"
                    fontFamily={'Poppins'}
                />
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <div className={styles.flexDirectionPayment}>
                        <div
                            className={styles.buttonCancel}
                            onClick={() => setShowCashModal(false)}
                        >
                            <Text
                                label="Cancelar la operación"
                                fontSize={16}
                                fontWeight={700}
                                color="white"
                            />
                        </div>

                        <div
                            className={styles.buttonSave}
                            onClick={handlePayWithCash}
                        >
                            <Text
                                label="Guardar"
                                fontSize={16}
                                fontWeight={700}
                                color="white"
                            />
                        </div>
                    </div>
                </div>
            </ModalComponent>
        )
    }

    const handlerAddProduct = () => {
        navigation(`/${routes.cart}`, {
            state: { cart: cart },
        })
    }

    const promotionModal = () => {
        return (
            <ModalComponent
                show={showPromotionModal}
                modalStyle={styles.promotionModalStyle}
                handleClose={() => {
                    setPromotionInfo(null)
                    setShowPromotionModal(false)
                }}
            >
                <div className={styles.promotionModalContainer}>
                    <SvgIcon iconName="SaleIlusGreen" />
                    <Text
                        label={`¡Atención! Tienes un descuento vigente del ${promotionInfo?.nDescuento}%`}
                        fontFamily="Montserrat"
                        color="#464646"
                        fontSize={20}
                        fontWeight={600}
                        textAlign="center"
                    />
                    <div className={styles.promotionModalGroupItem}>
                        <div className={styles.promotionModalItem}>
                            <Text
                                label="Monto total sin descuento:"
                                fontFamily="Montserrat"
                                color="#6C6C6C"
                                fontSize={16}
                                fontWeight={500}
                            />
                            <Text
                                label={formatCurrency(getTotalPay())}
                                fontFamily="Montserrat"
                                color="#6C6C6C"
                                fontSize={16}
                                fontWeight={600}
                            />
                        </div>
                        <div className={styles.promotionModalItem}>
                            <Text
                                label="Descuento vigente:"
                                fontFamily="Montserrat"
                                color="#6C6C6C"
                                fontSize={16}
                                fontWeight={500}
                            />
                            <Text
                                label={`${promotionInfo?.nDescuento}% OFF`}
                                fontFamily="Montserrat"
                                color="#6C6C6C"
                                fontSize={16}
                                fontWeight={600}
                            />
                        </div>
                    </div>
                    <div className={styles.promotionModalTotal}>
                        <Text
                            label="Total a cobrar:"
                            fontFamily="Montserrat"
                            color="#FAFBFA"
                            fontSize={16}
                            fontWeight={600}
                        />
                        <Text
                            label={formatCurrency(getTotalPayWithPromotion())}
                            fontFamily="Montserrat"
                            color="#FAFBFA"
                            fontSize={16}
                            fontWeight={600}
                        />
                    </div>
                    <div
                        onClick={navigateToQRPayment}
                        className={styles.promotionModalBtn}
                    >
                        <Text
                            label="Ir a cobrar"
                            fontFamily="Montserrat"
                            color="#fff"
                            fontSize={16}
                            fontWeight={600}
                        />
                    </div>
                </div>
            </ModalComponent>
        )
    }

    const manualPOSModal = () => {
        return (
            <ModalComponent
                show={showManualPOSModal}
                handleClose={() => setShowManualPOSModal(false)}
                icon={false}
                modalStyle={styles.modalPosNet}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        paddingLeft: 20,
                        paddingRight: 20,
                    }}
                >
                    <img
                        src={posnetModal}
                        height={88}
                        width={88}
                        style={{
                            alignSelf: 'center',
                            marginBottom: 26,
                            marginTop: 26,
                        }}
                    />
                    <div className={styles.efectivoContent}>
                        <span className={styles.efectivoSpan}>
                            <Text
                                label="Estás a punto de"
                                fontSize={16}
                                fontFamily="Poppins"
                                fontWeight={400}
                                as="span"
                            />
                            <Text
                                label=" registrar una venta con POS Manual"
                                fontSize={16}
                                fontFamily="Poppins"
                                fontWeight={700}
                                as="span"
                            />
                            <Text
                                label=" por un monto de: "
                                fontSize={16}
                                fontFamily="Poppins"
                                fontWeight={400}
                                as="span"
                            />
                            <Text
                                label={formatCurrency(getTotalPay())}
                                fontSize={16}
                                fontFamily="Poppins"
                                fontWeight={700}
                                as="span"
                            />
                            <Text
                                label={` Recuerda que las venta con POS de\nTerceros no será registrado en la proforma`}
                                fontSize={16}
                                fontFamily="Poppins"
                                fontWeight={400}
                                as="span"
                            />
                            <Text
                                label={' amiPASS.'}
                                fontSize={16}
                                fontFamily="Poppins"
                                fontWeight={400}
                                as="span"
                            />
                        </span>
                        <Text
                            label="¿Está correcto?"
                            fontSize={16}
                            fontFamily="Poppins"
                            fontWeight={700}
                            textAlign={'center'}
                            as="span"
                        />
                    </div>
                    <div
                        style={{
                            alignSelf: 'center',
                            display: 'flex',
                            marginTop: 20,
                        }}
                    >
                        <SquareCheckBox
                            noBackground
                            checkId="f2fId"
                            labelClassName="Body3-12 "
                            label="No volver a mostrar este mensaje"
                            onClick={() => setDoNotShowAgain(!doNotShowAgain)}
                            checked={doNotShowAgain}
                        />
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            marginLeft: 10,
                            marginRight: 10,
                            marginTop: 32,
                        }}
                    >
                        <div
                            onClick={() => setShowManualPOSModal(false)}
                            style={{
                                height: 36,
                                width: 180,
                                backgroundColor: '#565656',
                                borderRadius: 5,
                                alignContent: 'center',
                                cursor: 'pointer',
                                marginRight: 16,
                            }}
                        >
                            <Text
                                label="Cancelar la operación"
                                textAlign={'center'}
                                color={'white'}
                                fontWeight={700}
                                fontSize={14}
                                fontFamily={'Montserrat'}
                            />
                        </div>
                        <div
                            onClick={handlePayWithPOSManual}
                            style={{
                                height: 36,
                                width: 141,
                                backgroundColor: '#0086D6',
                                borderRadius: 5,
                                alignContent: 'center',
                                marginBottom: 20,
                                cursor: 'pointer',
                            }}
                        >
                            <Text
                                label="Registrar"
                                textAlign={'center'}
                                color={'white'}
                                fontWeight={700}
                                fontSize={14}
                                fontFamily={'Montserrat'}
                            />
                        </div>
                    </div>
                </div>
            </ModalComponent>
        )
    }

    return (
        <div className={styles.containertop}>
            <Text
                label={'Cobrar con amiPASS'}
                fontSize={20}
                fontWeight={600}
                color="#565656"
                marginBottom={20}
                style={{ alignSelf: 'flex-start' }}
            />

            <div className={styles.parent}>
                <div className={styles.paymentArrowBackContainer}>
                    <div
                        className={styles.backIconContainer}
                        onClick={navigateBack}
                    >
                        <img src={arrowBack} className={styles.arrowStyle} />
                    </div>
                    <Text
                        label={labels.back}
                        variant="md-medium titleStyle "
                        fontWeight={500}
                        marginBottom={5}
                        marginTop={5}
                    />
                </div>
                <div className={styles.container}>
                    <div className={styles.commonMargin}>
                        <Text
                            label={labels.paymentChoosPaymentMethod}
                            variant="H6 titleStyle"
                            color="#184287"
                            fontSize={19}
                            fontWeight={500}
                            marginTop={16}
                            marginBottom={16}
                        />
                        <Text
                            label={
                                cart && cart.length > 0
                                    ? 'Monto adicional '
                                    : labels.paymentTotalAmount
                            }
                            variant="H6 titleStyle"
                        />

                        <div className={styles.alertInputContent}>
                            <input
                                placeholder="$0"
                                value={price}
                                onChange={handleChangePrice}
                                className={`${styles.inputStyle} ${styles.alertInput}`}
                                id={styles.inputID}
                            />
                            <div className={styles.alertInputMsContent}>
                                {cart && cart.length > 0 && (
                                    <div style={{ position: 'relative' }}>
                                        <div
                                            style={{ cursor: 'pointer' }}
                                            onClick={() =>
                                                setShowMessageEfecty(
                                                    !showMessageEfecty
                                                )
                                            }
                                        >
                                            <SvgIcon iconName="IconInfoBlue" />
                                        </div>
                                        {showMessageEfecty && (
                                            <div
                                                className={
                                                    styles.alertInputMsContainer
                                                }
                                            >
                                                <Text
                                                    color="#fff"
                                                    fontSize={14}
                                                    fontWeight={600}
                                                    fontFamily="Montserrat"
                                                    label="Utiliza este campo si quieres agregar un monto adicional a cobrar"
                                                />
                                                <div
                                                    className={
                                                        styles.alertInputMsContainerX
                                                    }
                                                    onClick={() =>
                                                        setShowMessageEfecty(
                                                            false
                                                        )
                                                    }
                                                >
                                                    <SvgIcon iconName="IconXWhite" />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                        {cart && cart.length > 0 && (
                            <>
                                <Text
                                    label="Monto inventariado"
                                    variant="H6 titleStyle"
                                />
                                <div style={{ marginBottom: 10 }}>
                                    <input
                                        disabled={true}
                                        value={formatCurrency(getTotalCart())}
                                        className={`${styles.inputStyle} ${styles.inputsCart}`}
                                        id={styles.inputID}
                                    />
                                </div>
                                <Text
                                    label="Monto a cobrar"
                                    variant="H6 titleStyle"
                                />
                                <div style={{ marginBottom: 10 }}>
                                    <input
                                        disabled={true}
                                        value={formatCurrency(getTotalPay())}
                                        className={`${styles.inputStyle} ${styles.inputsCart}`}
                                        id={styles.inputID}
                                    />
                                </div>
                            </>
                        )}
                        <div className={styles.paymentMethodTitle}>
                            <Text
                                label={labels.paymentMethod}
                                fontSize={16}
                                fontWeight={600}
                                marginTop={10}
                                marginBottom={15}
                                color={'#565656'}
                            />
                        </div>
                        <div
                            className={
                                getTotalPay() === 0
                                    ? styles.buttonContainerDisabled
                                    : styles.buttonContainer
                            }
                            style={{
                                marginBottom: 20,
                            }}
                            onClick={getPromotionsQRAsync}
                            aria-disabled={getTotalPay() === 0 ? true : false}
                        >
                            {getTotalPay() === 0 ? (
                                <img
                                    src={qrDisabled}
                                    className={styles.buttonTextStyleDisabled}
                                />
                            ) : (
                                <img
                                    src={qrSvg}
                                    className={styles.buttonTextStyle}
                                />
                            )}
                            <Text
                                label={labels.paymentAmipass}
                                variant={
                                    getTotalPay() === 0
                                        ? `subtitle1 ${styles.buttonTextStyleDisabled} ${styles.textMargin}`
                                        : `subtitle1 ${styles.buttonTextStyle} ${styles.textMargin}`
                                }
                            />
                            <Text
                                label={labels.paymentQR}
                                variant={
                                    getTotalPay() === 0
                                        ? `subtitle1 ${styles.buttonTextStyleDisabled} ${styles.textMargin}`
                                        : `subtitle1 ${styles.buttonTextStyle} ${styles.blue}`
                                }
                            />
                        </div>
                        {features?.terminal.bci && (
                            <div
                                className={
                                    getTotalPay() === 0 ||
                                    !features.terminal.bci
                                        ? styles.buttonContainerDisabled
                                        : styles.buttonContainer
                                }
                                onClick={handleOnProcessBCI}
                                aria-disabled={
                                    getTotalPay() === 0 || !features.terminal
                                        ? true
                                        : false
                                }
                                style={{
                                    marginBottom: 20,
                                }}
                            >
                                <img
                                    src={bciPayLogo}
                                    className={
                                        getTotalPay() === 0 ||
                                        !features.terminal.bci
                                            ? styles.bciImageDisable
                                            : styles.bciPayButtonContainer
                                    }
                                />
                            </div>
                        )}
                        {features?.terminal.getnetc2c && (
                            <div
                                className={
                                    getTotalPay() === 0 ||
                                    !features.terminal.getnetc2c
                                        ? styles.buttonContainerDisabled
                                        : styles.buttonContainer
                                }
                                onClick={handleOnProcessGetnet}
                                aria-disabled={
                                    getTotalPay() === 0 ||
                                    !features.terminal.getnetc2c
                                        ? true
                                        : false
                                }
                                style={{
                                    marginTop: '20px',
                                    marginBottom: 20,
                                }}
                            >
                                <img
                                    src={getnetPayLogo}
                                    className={
                                        getTotalPay() === 0 ||
                                        !features.terminal.getnetc2c
                                            ? styles.bciImageDisable
                                            : styles.bciPayButtonContainer
                                    }
                                />
                            </div>
                        )}
                        {features?.pos_payment && (
                            <div
                                className={
                                    getTotalPay() === 0
                                        ? styles.buttonContainerDisabled
                                        : styles.buttonContainer
                                }
                                aria-disabled={
                                    getTotalPay() === 0 ? true : false
                                }
                                style={{ marginBottom: 20 }}
                                onClick={() => {
                                    if (doNotShowAgain) {
                                        handlePayWithPOSManual()
                                    } else {
                                        setShowManualPOSModal(true)
                                    }
                                }}
                            >
                                <img
                                    src={posnet}
                                    style={{
                                        height: 26,
                                        width: 37,
                                    }}
                                />

                                <Text
                                    label={'Registrar Venta con POS Manual'}
                                    fontSize={16}
                                    fontWeight={600}
                                    fontFamily={'Nunito'}
                                    variant={
                                        getTotalPay() === 0
                                            ? `subtitle1 ${styles.buttonTextStyleDisabled} ${styles.textMargin}`
                                            : `subtitle1 ${styles.buttonTextStyle} ${styles.blue}`
                                    }
                                />
                            </div>
                        )}

                        {features?.cashPayment && (
                            <div
                                className={
                                    getTotalPay() === 0
                                        ? styles.buttonContainerDisabled
                                        : styles.buttonContainer
                                }
                                onClick={handleCashSale}
                                aria-disabled={
                                    getTotalPay() === 0 ? true : false
                                }
                            >
                                <img
                                    src={cash}
                                    style={{
                                        height: 35,
                                        width: 46,
                                        marginRight: 10,
                                    }}
                                    className={
                                        getTotalPay() === 0 ||
                                        !features.cashPayment
                                            ? styles.bciImageDisable
                                            : styles.bciPayButtonContainer
                                    }
                                />

                                <Text
                                    label={'Registrar Venta en Efectivo'}
                                    fontSize={16}
                                    fontWeight={600}
                                    fontFamily={'Nunito'}
                                    variant={
                                        getTotalPay() === 0
                                            ? `subtitle1 ${styles.buttonTextStyleDisabled} ${styles.textMargin}`
                                            : `subtitle1 ${styles.buttonTextStyle} ${styles.blue}`
                                    }
                                />
                            </div>
                        )}
                    </div>
                </div>
                {features?.cart_f2f && (
                    <div
                        onClick={handlerAddProduct}
                        className={styles.buttonContainerAddProduct}
                    >
                        <Text
                            label={
                                cart && cart.length > 0
                                    ? `Productos en el carro (${cart.reduce(
                                          (acc, curr) => acc + curr.cant,
                                          0
                                      )})`
                                    : 'Agregar producto a esta venta'
                            }
                            fontFamily="Montserrat"
                            fontWeight={600}
                            color="#ffffff"
                            fontSize={16}
                        />
                        <div className={styles.buttonContainerAddProductIcon}>
                            <SvgIcon iconName="IconAddProducts" />
                        </div>
                    </div>
                )}
            </div>

            {promotionModal()}
            {cashModal()}
            {manualPOSModal()}
        </div>
    )
}
